import { UserLabel } from '@app/pcs/models';
import { ValdrConstraints } from '@app/valdr';
import { Action } from '@ngrx/store';

export enum LabelEditActionTypes {
  InitLabelForm = '[LabelEdit] Init Label Form',
  CreateLabelForm = '[LabelEdit] Create Label Form',
  DisplayEditLabelForm = '[LabelEdit] Display Edit Label Form',

  ToggleEditLabelForm = '[LabelEdit] Toggle Edit Label Form',
  ResetState = '[LabelEdit] Reset State'
}

export class DisplayEditLabelForm implements Action {
  readonly type = LabelEditActionTypes.DisplayEditLabelForm;

  constructor(public payload: UserLabel) {
  }
}

export class InitLabelForm implements Action {
  readonly type = LabelEditActionTypes.InitLabelForm;

  constructor(public payload: UserLabel) {
  }
}

export class CreateLabelForm implements Action {
  readonly type = LabelEditActionTypes.CreateLabelForm;

  constructor(public payload: { userLabel: UserLabel; valdrConstraints: ValdrConstraints }) {
  }
}

export class ToggleEditLabelForm implements Action {
  readonly type = LabelEditActionTypes.ToggleEditLabelForm;
}

export class ResetState implements Action {
  readonly type = LabelEditActionTypes.ResetState;
}

export type LabelEditActions =
  | DisplayEditLabelForm
  | InitLabelForm
  | CreateLabelForm
  | ToggleEditLabelForm
  | ResetState;
